enum currencyEnum {
  Amount = "{{amount}}",
  AmountNoDecimals = "{{amount_no_decimals}}",
  AmountWithCommaSeparator = "{{amount_with_comma_separator}}",
  AmountNoDecimalsWithCommaSeparator = "{{amount_no_decimals_with_comma_separator}}",
  AmountWithApostropheSeparator = "{{amount_with_apostrophe_separator}}",
  AmountNoDecimalsWithSpaceSeparator = "{{amount_no_decimals_with_space_separator}}",
  AmountWithSpaceSeparator = "{{amount_with_space_separator}}",
  AmountWithPeriodAndSpaceSeparator = "{{amount_with_period_and_space_separator}}",
}
/**
 * shopify 货币格式
 * {{ amount }}    1,134.65s
 * {{ amount_no_decimals }}  ✓  1,135
 * {{ amount_with_comma_separator }}    1.134,65
 * {{ amount_no_decimals_with_comma_separator }}  ✓  1.135
 * {{ amount_with_apostrophe_separator }}    1'134.65
 */

interface IFormatPriceByTemplateProps {
  value: number | string
  formatType: currencyEnum | string
  hideDecimalsWhenInteger?: boolean
}

export const formatPriceByTemplate = (
  props: IFormatPriceByTemplateProps,
): string => {
  const { value, formatType, hideDecimalsWhenInteger = false } = props
  // 去除括号内空格
  const cleanedFormatType = formatType?.replace(
    /{{\s*([^{}]*)\s*}}/g,
    (_, p1) => `{{${p1.replace(/\s+/g, "")}}}`,
  )

  // 去除括号前后
  const cleanedAmount = cleanedFormatType.match(/(\{\{.*?\}\})/)

  const currencyType = cleanedAmount
    ? JSON.parse(JSON.stringify(cleanedAmount[1]))
    : ""

  const amount = Number(value)
  const options: Intl.NumberFormatOptions = {
    useGrouping: true,
  }
  let formattedAmount: string

  switch (currencyType) {
    case currencyEnum.Amount:
      formattedAmount = amount.toLocaleString()
      break

    case currencyEnum.AmountNoDecimals:
      options.maximumFractionDigits = 0
      formattedAmount = amount.toLocaleString(undefined, options)
      break

    case currencyEnum.AmountWithCommaSeparator:
      formattedAmount = amount.toLocaleString("de-DE", options)
      break

    case currencyEnum.AmountNoDecimalsWithCommaSeparator:
      options.maximumFractionDigits = 0
      formattedAmount = amount.toLocaleString(undefined, options)
      break

    case currencyEnum.AmountWithApostropheSeparator:
      formattedAmount = amount
        .toLocaleString("en-US", options)
        .replace(/,/g, "'")
      break

    case currencyEnum.AmountNoDecimalsWithSpaceSeparator:
      options.maximumFractionDigits = 0
      formattedAmount = amount.toLocaleString("fr-FR", options)
      break

    case currencyEnum.AmountWithSpaceSeparator:
      formattedAmount = amount.toLocaleString("fr-FR", options)
      break

    case currencyEnum.AmountWithPeriodAndSpaceSeparator:
      formattedAmount = amount.toLocaleString("en-GB", options)
      break

    default:
      formattedAmount = amount.toLocaleString()
  }

  if (
    !hideDecimalsWhenInteger &&
    /^\d{1,3}(?:,\d{3})*$/.test(formattedAmount)
  ) {
    formattedAmount = formattedAmount + ".00"
  }
  // 如果是小数且小数部分只有一位，添加 0
  else if (/^\d{1,3}(?:,\d{3})*\.\d{1}$/.test(formattedAmount)) {
    formattedAmount = formattedAmount + "0"
  }

  // 使用传入的格式类型替换金额占位符
  return cleanedFormatType
    .replace(/{{amount}}/g, formattedAmount)
    .replace(/{{amount_no_decimals}}/g, formattedAmount.replace(/\.\d+$/, ""))
    .replace(/{{amount_with_comma_separator}}/g, formattedAmount)
    .replace(
      /{{amount_no_decimals_with_comma_separator}}/g,
      formattedAmount.replace(/\.\d+$/, ""),
    )
    .replace(
      /{{amount_with_apostrophe_separator}}/g,
      formattedAmount.replace(/,/g, "'"),
    )
    .replace(
      /{{amount_no_decimals_with_space_separator}}/g,
      formattedAmount.replace(/\.\d+$/, "").replace(/,/g, " "),
    )
    .replace(
      /{{amount_with_space_separator}}/g,
      formattedAmount.replace(/,/g, " "),
    )
    .replace(
      /{{amount_with_period_and_space_separator}}/g,
      formattedAmount.replace(/,/g, " ").replace(/\./g, " ."),
    )
}
